import { useEffect } from 'react'

export function useScrollReveal(rootRef, key) {
  useEffect(() => {
    const root = rootRef.current
    if (!root) return undefined

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          entry.target.setAttribute('data-revealed', '')
          observer.unobserve(entry.target)
        })
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' },
    )

    const bind = (el) => {
      if (!(el instanceof Element) || el.hasAttribute('data-revealed')) {
        return
      }
      const parent = el.parentElement
      if (parent?.hasAttribute('data-reveal-stagger')) {
        const siblings = [...parent.querySelectorAll(':scope > [data-reveal]')]
        const index = siblings.indexOf(el)
        el.style.setProperty('--reveal-delay', `${index * 90}ms`)
      }
      observer.observe(el)
    }

    root.querySelectorAll('[data-reveal]').forEach(bind)

    const mutations = new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return
          if (node.hasAttribute('data-reveal')) bind(node)
          node.querySelectorAll?.('[data-reveal]').forEach(bind)
        })
      })
    })

    mutations.observe(root, { childList: true, subtree: true })

    return () => {
      observer.disconnect()
      mutations.disconnect()
    }
  }, [key])
}
